// src/Components/SessionTimer.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const SessionTimer = ({ duration = 6 * 60 * 1000 }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/timeout');
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, navigate]);

  return null; // No UI
};

export default SessionTimer;
